import { supabase } from './integrations/supabase'

export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession()
  return session
}

export function onAuthStateChange(cb: (event: string, session: any) => void) {
  const { data } = supabase.auth.onAuthStateChange((event: string, session: any) => cb(event, session))
  return () => data.subscription?.unsubscribe?.()
}

export async function signOut() {
  return supabase.auth.signOut()
}
